import { useTranslation } from 'react-i18next'
import Modal from '../Modal'
import styles from './SelectedTableModal.module.scss'

import Button from '../../Button/Button'
import { useFormDirtyStore } from '@/store/useFormDirtyStore'
import Keyboard from '@/components/Keyboard/Keyboard'
import TextField from '@/components/TextField/TextField'

interface SelectedTableModalProps {
  tableNumber: number
  guestsNumberValue: string
  setGuestsNumberValue: (guestNumber: string) => void
  onConfirm: () => void
  onClose: () => void
  isOpen: boolean
}

function SelectedTableModal(props: SelectedTableModalProps) {
  const {
    tableNumber,
    guestsNumberValue,
    setGuestsNumberValue,
    onConfirm,
    onClose,
    isOpen
  } = props
  const { t } = useTranslation()
  const resetIsDirty = useFormDirtyStore(s => s.reset)

  const handleOnConfirm = () => {
    resetIsDirty()
    onConfirm()
  }

  const title = `${t('SELECTED_TABLE.MODAL.TITLE')} ${tableNumber}`
  const message = t('SELECTED_TABLE.MODAL.DESCRIPTION')

  const setKeyboardValue = (value: number) => {
    if (setGuestsNumberValue) {
      if (value === 0 && guestsNumberValue?.length === 0) {
        return
      }
      if ((guestsNumberValue ?? '').length < 2) {
        const updatedValue = guestsNumberValue + String(value)
        setGuestsNumberValue(updatedValue)
      }
    }
  }

  const clearKeyboardValue = () => {
    if (setGuestsNumberValue) {
      setGuestsNumberValue('')
    }
  }

  const deleteLastKeyboardValue = () => {
    if (setGuestsNumberValue && guestsNumberValue) {
      setGuestsNumberValue(guestsNumberValue.slice(0, -1))
    }
  }
  return (
    <Modal title={title} isOpen={isOpen} onClose={onClose} size="small">
      <div className={styles.selectedTableContainer}>
        <p className={`title-medium ${styles.selectedTableSubHeader}`}>
          {message}
        </p>
        <div className={styles.selectedTableContentContainer}>
          <TextField disabled value={String(guestsNumberValue)} />
          <Keyboard
            setValue={setKeyboardValue}
            clearValue={clearKeyboardValue}
            deleteValue={deleteLastKeyboardValue}
          />
        </div>
        <div className={styles.selectedTableButtonContainer}>
          <Button
            color="primary"
            label={t('COMMON.CONFIRM')}
            variant="contained"
            onClick={handleOnConfirm}
            mobile
            width="100%"
            disabled={!guestsNumberValue}
          />
        </div>
      </div>
    </Modal>
  )
}

export default SelectedTableModal
